module.exports = __webpack_public_path__ + "media/images/number_0-fec58d636a5d76b3f055f4fca17b8e5f.png";